import { useLang } from "./LanguageContext";

const PATRIZIAS_LOGO =
  "https://images.getbento.com/accounts/78540d47b961291fe22c29ae3eb8a893/media/images/12400Patrizias-Brush.png?w=600&auto=compress,format";

const copy = {
  en: { craft: "The Craft", models: "Business Models", gallery: "Gallery", enquire: "Enquire" },
  it: { craft: "Il Mestiere", models: "Modelli di Business", gallery: "Galleria", enquire: "Contatti" },
  ru: { craft: "Ремесло", models: "Бизнес-модели", gallery: "Галерея", enquire: "Контакты" },
  es: { craft: "El Oficio", models: "Modelos de Negocio", gallery: "Galería", enquire: "Contacto" },
};

export const Footer = ({ brand = "filata" }) => {
  const { lang } = useLang();
  const t = copy[lang];
  return (
    <footer className="bg-wine text-bg border-t border-bg/15" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-14 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <div>
          {brand === "patrizias" ? (
            <img src={PATRIZIAS_LOGO} alt="Patrizia's" className="h-16 md:h-20 w-auto" />
          ) : (
            <p className="font-serif text-4xl md:text-5xl text-bg">Filata<span className="text-terracotta">.</span></p>
          )}
          <p className="font-sans text-sm text-bg/50 mt-3">Live Mozzarella Experience</p>
          {brand !== "patrizias" && (
            <div className="mt-2">
              <a href="mailto:info@filataexperience.com" data-testid="footer-email" className="font-sans text-sm text-terracotta hover:text-bg transition-colors block">
                info@filataexperience.com
              </a>
              <a href="mailto:raffaele@filataexperience.com" data-testid="footer-email-raffaele" className="font-sans text-sm text-bg/60 hover:text-terracotta transition-colors block mt-1">
                Raffaele Orlando · raffaele@filataexperience.com
              </a>
            </div>
          )}
        </div>
        <div className="flex flex-wrap gap-6 font-sans text-sm text-bg/60">
          <a href="#craft" className="hover:text-bg transition-colors">{t.craft}</a>
          <a href="#business-models" className="hover:text-bg transition-colors">{t.models}</a>
          <a href="#gallery" className="hover:text-bg transition-colors">{t.gallery}</a>
          <a href="#book" className="hover:text-bg transition-colors">{t.enquire}</a>
        </div>
        <p className="font-sans text-xs text-bg/40">© {new Date().getFullYear()} {brand === "patrizias" ? "Patrizia\u2019s" : "Filata"} — Live Mozzarella Experience.{brand !== "patrizias" && " filataexperience.com"}</p>
      </div>
    </footer>
  );
};
